(function ($) {


    this.init = function () {
        this.FooterLinks();
    };


    /****************************************************************
     HOMEPAGE BANNER
    ****************************************************************/
    this.FooterLinks = function () {
        $(".footer-links-right-navigation-mobileheader").on("click", function () {
            var $next = $(this).next();

            if ($next.hasClass("open")) {
                $next.removeClass("open");
                $next.attr("aria-hidden", true);
                $(this).attr("aria-expanded", false);
                $(this).removeClass("open");
            } else {
                $next.addClass("open");
                $next.attr("aria-hidden", false);
                $(this).addClass("open");
                $(this).attr("aria-expanded", true);
            }
        });
    }

    this.init();

})(jQuery);